import { TabStyles } from '@tableau/widgets';
import { CSSProperties } from 'react';

import { cssClass } from '~src/style';


const classPrefix = 'filter-panel';

export const filteringListContainerHeight = 300;

export const filterComponentStyle: CSSProperties = {
  marginTop: TabStyles.Spacing.MediumSpace,
  width: '100%',
};

export const filterPanelContainer = cssClass(classPrefix, 'container', {
  display: 'block',
  marginLeft: TabStyles.Spacing.LargeSpace,
  marginRight: TabStyles.Spacing.LargeSpace,
  marginBottom: TabStyles.Spacing.ExtraLargeSpace,
  marginTop: '2px' // Room for the focus indicator
});

export const clearAllButton = cssClass(classPrefix, 'clear-all', {
  display: 'block',
  marginRight: 0,
  marginLeft: 'auto',
});

export const clearFilterButton = cssClass(classPrefix, 'clear-filter', {
  position: 'absolute',
  top: 0,
  right: 0,
  $nest: {
    '&:not(:hover)': {
      backgroundColor: 'white'
    }
  }
});

export const searchInput = cssClass(classPrefix, 'search-input', {
  width: '100%',
});

export const groupHeader = cssClass(classPrefix, 'group-header', {
  marginTop: TabStyles.Spacing.ExtraLargeSpace,
  fontWeight: 'bold'
});

export const filterWrapper = cssClass(classPrefix, 'filterWrapper', {
  ...filterComponentStyle,
  position: 'relative'
});

export const filterComponent = cssClass(classPrefix, 'filter', filterComponentStyle);

export const filterComponentGroup = cssClass(classPrefix, 'filter-group', {
  ...filterComponentStyle,
  $nest: {
    'label:not(:first-of-type)': {
      marginTop: TabStyles.Spacing.DefaultSpace
    }
  }
});

export const dropdownListContainer = cssClass(classPrefix, 'dropdown-list', {
  maxHeight: filteringListContainerHeight
});

export const dropdownListItemLeftAligned = cssClass(classPrefix, 'dropdown-list-item-left', {
  display: 'inline-block',
  textOverflow: 'ellipsis',
  maxWidth: 'calc(100% - 36px)',
  overflowX: 'hidden',
  verticalAlign: 'middle'
});

export const dropdownListItemRightAligned = cssClass(classPrefix, 'dropdown-list-item-right', {
  float: 'right',
  verticalAlign: 'middle'
});
